import {Component, Input} from '@angular/core';
import {DeutschlandwetterOpenMedia} from '../../../../../../../model/vorhersagen/rbb-document';

@Component({
  selector: 'app-deutschlandwetter-bericht',
  templateUrl: './deutschlandwetter-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class DeutschlandwetterBerichtComponent {

  @Input()
  deutschlandwetterOpenMedia?: DeutschlandwetterOpenMedia;

}
